import LogsList from './views/LogList'

export default {
  name:"logs",
  list:LogsList,
}